import React from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";

function RefundPolicy() {
  return (
         <>
    <Head />
    
    
  {/* Start Breadcrumbs */}
  <section className="ak-about-hero-1">
    <img
      src="assets/img/bg/policy.jpg"
      className="about-hero-bg ak-bg object-cover"
      alt="..."
      data-swiper-parallax={1152}
    />
    <div className="container">
      <div className="about-hero-content">
        <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
          <p
            className="ak-section-subtitle animation-title"
            style={{ color: "white !important" }}
          >
            Policy
          </p>
          <h2
            className="ak-section-title animation-title"
            style={{ color: "white" }}
          >
            Refund Policy
          </h2>
        </div>
        <a href="/" className="back-btn" style={{ color: "white" }}>
          Home / Policy / Refund Policy
        </a>
      </div>
    </div>
  </section>
  {/* End Breadcrumbs */}
  {/* Start About  */}
  <div className="ak-height-125 ak-height-lg-80" />
  <section>
    <div className="about-us-content-bg">
      <div className="container">
        {/* <div className="about-us-content"> */}
         
<div className="info-content">
  <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
    <p className="ak-section-subtitle animation-title">
      POLICY
    </p>
    <h2 className="ak-section-title animation-title">
      REFUND POLICY
    </h2>

    <p className="ak-section-desp">
      At IFMEDU ACADEMY PRIVATE LIMITED, we are committed to providing high-quality educational programs and services. This Refund Policy outlines the terms under which course fees may be refunded.
    </p>

    <p className="ak-section-desp">
      <strong>1. Student-Initiated Withdrawal</strong><br />
      If a student chooses to discontinue or withdraw from a course after enrollment, for any reason, the fees paid will <strong>not be refunded</strong>. This includes partial payments, down payments, and monthly installments. Students are encouraged to review course details and schedules carefully before enrolling.
    </p>

    <p className="ak-section-desp">
      <strong>2. IFMEDU-Initiated Cancellation</strong><br />
      If IFMEDU ACADEMY PRIVATE LIMITED cancels or discontinues a course due to unforeseen circumstances, lack of enrollment, or administrative decisions, students will be eligible for a <strong>full refund of the fees paid</strong> for that specific course. Refunds will be processed within 30 working days of notification.
    </p>

    <p className="ak-section-desp">
      <strong>3. Refund Process</strong><br />
      Eligible refunds will be issued via the original payment method or through direct bank transfer. Students must submit a formal refund request via email to <a href="mailto:enquiry@ifmedu.in">enquiry@ifmedu.in</a> with proof of payment and enrollment details.
    </p>

    <p className="ak-section-desp">
      <strong>4. Non-Refundable Items</strong><br />
      The following are strictly non-refundable:
      <ul>
        <li>Registration fees</li>
        <li>Certificate processing fees (if already issued)</li>
        <li>Practical attachment fees (if training has commenced)</li>
        <li>Administrative charges</li>
      </ul>
    </p>

    <p className="ak-section-desp">
      <strong>5. Dispute Resolution</strong><br />
      Any disputes regarding refunds will be reviewed by the IFMEDU administrative team. Final decisions will be communicated in writing and are binding.
    </p>

    <p className="ak-section-desp">
      <strong>6. Contact Us</strong><br />
      For refund inquiries or to submit a request, please contact:<br />
      📧 enquiry@ifmedu.in<br />
      📞 +91 90486 48777<br />
      📍 IFMEDU ACADEMY PRIVATE LIMITED, VSK TOWER, Opp. TVS Junction, Ernakulam, Kerala – 682019
    </p>
  </div>
</div>
        {/* </div> */}
        <div className="ak-height-125 ak-height-lg-80" />
      </div>
      <img className="aboutus" src="assets/img/bg/aboutus.png" alt="..." />
    </div>
  </section>
  {/* End About  */}




    <Foot />
    </>
  )
}

export default RefundPolicy